"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "authReducer", {
  enumerable: true,
  get: function get() {
    return _auth.default;
  }
});
exports.authSelectors = exports.authActions = void 0;

var _auth = _interopRequireWildcard(require("./auth"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
} // AUTH
// Import actions
// Import selectors
// Import reducer


var authActions = {
  authenticate: _auth.authenticate,
  invalidateToken: _auth.invalidateToken,
  loadMe: _auth.loadMe,
  loadOauthProviders: _auth.loadOauthProviders,
  usernameLogin: _auth.usernameLogin,
  showLoginOptions: _auth.showLoginOptions,
  showGirderLogin: _auth.showGirderLogin,
  testOauthEnabled: _auth.testOauthEnabled,
  setAuthenticating: _auth.setAuthenticating,
  showNerscLogin: _auth.showNerscLogin,
  nerscLogin: _auth.nerscLogin,
  setMe: _auth.setMe,
  setToken: _auth.setToken
};
exports.authActions = authActions;
var authSelectors = {
  setRoot: _auth.setRoot,
  getMe: _auth.getMe,
  getToken: _auth.getToken,
  getOauthProviders: _auth.getOauthProviders,
  isOauthEnabled: _auth.isOauthEnabled,
  isAuthenticated: _auth.isAuthenticated,
  isAuthenticating: _auth.isAuthenticating,
  getShowLoginOptions: _auth.getShowLoginOptions,
  getShowGirderLogin: _auth.getShowGirderLogin,
  getShowNerscLogin: _auth.getShowNerscLogin
};
exports.authSelectors = authSelectors;